module.exports = __webpack_public_path__ + "img/92_13.00828298.png";